import React, { ChangeEvent, FocusEvent, ReactNode } from 'react';
import {
  Select as SelectContainer,
  SelectProps
} from '../../../components/Form';
import { SvgIcon } from '../../../components/SvgIcon';

export interface FormSelectProps extends SelectProps {
  children?: ReactNode;
  value: string;
  name?: string;
  onBlur: (e: FocusEvent<HTMLSelectElement>) => void;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  inline?: boolean;
  ghost?: boolean;
  small?: boolean;
  error?: boolean;
}

const Select = ({
  children,
  value,
  onBlur,
  onChange,
  name,
  ...containerProps
}: FormSelectProps) => (
  <SelectContainer {...containerProps}>
    <select value={value} name={name} onChange={onChange} onBlur={onBlur}>
      {children}
    </select>
    <SvgIcon icon="arrow" />
  </SelectContainer>
);

export default Select;
